import React from 'react';
import AppHeadline from 'components/Headline';

const Headline = () => {
    return <AppHeadline label="Abstracts Submission" />;
};

export default Headline;
